import {
  DOCUMENT_UUID,
  FORM_SUBMIT_SUCCESS,
  FORM_SUBMIT_ERROR,
  DOCUMENT_PURGE
} from "../../constants/constants";

const initialState = {
  documentUUID: null,
  zahtjevAtrId: null,
  formId: null,
  error: false,
  notificationMessage: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_UUID:
      return {
        ...state,
        documentUUID: action.uuid,
        zahtjevAtrId: action.zahtjevAtrId,
        formId: action.formId,
        error: false,
      };
    case FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        error: action.error,
        notificationMessage: action.notificationMessage,
      };
    case FORM_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
        notificationMessage: action.notificationMessage,
      };

    case DOCUMENT_PURGE:
      return {
        ...initialState,
      };

    default: {
      return state;
    }
  }
};
